import { Action } from 'redux';
import { APIError } from '../../helpers/types';
import { TransferStatus } from '../../models/profile';

export enum ProfileTransferTypes {
  TRANSFER_PROFILE_SUBMIT = 'TRANSFER_PROFILE_SUBMIT',
  TRANSFER_PROFILE_SUBMIT_SUCCESS = 'TRANSFER_PROFILE_SUBMIT_SUCCESS',
  TRANSFER_PROFILE_SUBMIT_FAILURE = 'TRANSFER_PROFILE_SUBMIT_FAILURE',
  TRANSFER_ACCOUNT_EXIST_SUBMIT = 'TRANSFER_ACCOUNT_EXIST_SUBMIT',
  TRANSFER_ACCOUNT_EXIST_SUBMIT_SUCCESS = 'TRANSFER_ACCOUNT_EXIST_SUBMIT_SUCCESS',
  TRANSFER_ACCOUNT_EXIST_SUBMIT_FAILURE = 'TRANSFER_ACCOUNT_EXIST_SUBMIT_FAILURE',
}

export interface ActionProfileTransferSubmit extends Action {
  type: ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT;
}
export interface ActionProfileTransferSuccess extends Action {
  type: ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT_SUCCESS;
  payload: TransferStatus;
}
export interface ActionProfileTransferFailure extends Action {
  type: ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT_FAILURE;
  error: APIError;
}
export interface ActionDestinationAccountSubmit extends Action {
  type: ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT;
}
export interface ActionDestinationAccountSuccess extends Action {
  type: ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT_SUCCESS;
}
export interface ActionDestinationAccountFailure extends Action {
  type: ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT_FAILURE;
}
export type TransferActions =
  | ActionProfileTransferSubmit
  | ActionProfileTransferSuccess
  | ActionProfileTransferFailure
  | ActionDestinationAccountSubmit
  | ActionDestinationAccountSuccess
  | ActionDestinationAccountFailure;